import { useCallback, useEffect, useState } from "react";
import api, { apiErrorMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Download, FileSpreadsheet, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { FAT_VAZIO, FaturamentoFiltros } from "@/components/fiscal/FaturamentoFiltros";
import { FaturamentoTabela } from "@/components/fiscal/FaturamentoTabela";

const params = (f) => Object.fromEntries(
  [["ano", f.ano], ["mes", f.mes], ["uf_curso", f.uf], ["curso_id", f.curso]].filter(([, v]) => v),
);

export default function RelatorioFaturamento() {
  const [f, setF] = useState(FAT_VAZIO);
  const [dados, setDados] = useState({ linhas: [], totais: {}, cursos: [], ufs: [] });
  const [carregando, setCarregando] = useState(true);
  const [baixando, setBaixando] = useState(false);

  const load = useCallback(() => {
    setCarregando(true);
    api.get("/fiscal/relatorio-faturamento", { params: params(f) })
      .then((r) => setDados(r.data))
      .catch((e) => toast.error(apiErrorMsg(e, "Erro ao carregar o relatório")))
      .finally(() => setCarregando(false));
  }, [f]);
  useEffect(() => { load(); }, [load]);

  const baixar = async () => {
    setBaixando(true);
    try {
      const r = await api.get("/fiscal/relatorio-faturamento.xlsx", { params: { ...params(f), _: Date.now() }, responseType: "blob" });
      const nome = (r.headers["content-disposition"] || "").match(/filename="(.+)"/)?.[1] || "relatorio-faturamento.xlsx";
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url; a.download = nome; a.click();
      URL.revokeObjectURL(url);
      toast.success("Relatório baixado");
    } catch (e) { toast.error(apiErrorMsg(e, "Erro ao baixar o relatório")); } finally { setBaixando(false); }
  };

  return (
    <div className="space-y-4" data-testid="relatorio-faturamento-page">
      <div className="flex items-end justify-between gap-3 flex-wrap">
        <div>
          <h1 className="font-display text-3xl md:text-4xl font-bold text-slate-900 flex items-center gap-2">
            <FileSpreadsheet className="w-8 h-8 text-emerald-600" /> Relatório de faturamento
          </h1>
          <p className="text-sm text-slate-500 mt-1">Inscrições por curso, sem as canceladas, no modelo da planilha de receita.</p>
        </div>
        <Button onClick={baixar} disabled={baixando || !dados.linhas.length} className="bg-emerald-600 hover:bg-emerald-700" data-testid="fat-baixar">
          {baixando ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Download className="w-4 h-4 mr-2" />} Baixar Excel
        </Button>
      </div>
      <FaturamentoFiltros f={f} setF={setF} cursos={dados.cursos} />
      {carregando ? (
        <div className="p-10 text-center text-slate-500" data-testid="fat-carregando"><Loader2 className="w-6 h-6 animate-spin inline" /></div>
      ) : (
        <FaturamentoTabela linhas={dados.linhas} totais={dados.totais} />
      )}
    </div>
  );
}
